import axios from 'axios';
import { getTokenFromCookie } from '../utils/tokenHelper';
import config from '../data/config';
export const getApplicationByApplicantGuid = async (applicantGuid: string) => {
    try{
        const response = await axios.get(`/api/v1/interview/${applicantGuid}`);
        return response.data;
    } catch (error) {
        console.log('Error fetching application:', error);
    }
};

export const getApplicationByJobId = async (jobId: string) => {
    try{
        const token = getTokenFromCookie();
        const jwtSecret = config.JWT_SECRET;
        const response = await axios.get(`/api/v1/job/${jobId}`, {
            headers: {
                'Authorization': `Bearer ${jwtSecret}`
            }
        });
        return response.data;
    } catch (error) {
        console.log('Error fetching application:', error);
    }
};

export const initializeAnswersForInterview = async (applicantGuid: string) => {
    try{
        const response = await axios.post(`/api/v1/answer/${applicantGuid}/initialize`);
        console.log('Initialized answers for applicantGuid', applicantGuid);
        return response.data;
    } catch (error) {
        console.log('Error saving interview:', error);
    }
};

export const saveInterview = async (payload: any) => {
    try{
        // console.log('received payload', payload);
        const interviewStatus = {
            status: "Completed"
          };
        await axios.patch(`/api/v1/interview/${payload.applicantGuid}`, interviewStatus);
        const response = await axios.post(`/api/v1/interview/responses`, payload);
        return response.data;
    } catch (error) {
        console.log('Error saving interview:', error);
    }
};
